import * as types from './types';

// General type of LoadingState ui hook - loaders that would appear inline should use this
export const startApiRequest = (payload) => {
  return dispatch => {
    const requestActions = payload;
    if (Array.isArray(requestActions)) {
      requestActions.forEach(requestAction => {
        dispatch({
          type: types.REQUEST_PENDING,
          payload: requestAction,
        });
      });
    } else {
      dispatch({
        type: types.REQUEST_PENDING,
        payload: payload,
      });
    }
  };
};

// General type of LoadingState ui hook - loaders that would appear inline should use this
export const endApiRequest = (payload) => {
  return dispatch => {
    const requestActions = payload;
    if (Array.isArray(requestActions)) {
      // console.log('endApiRequest Array.isArray(requestActions) REQUEST_COMPLETE = ', payload);
      requestActions.forEach(requestAction => {
        dispatch({
          type: types.REQUEST_COMPLETE,
          payload: requestAction,
        });
      });
    } else {
      // console.log('endApiRequest REQUEST_COMPLETE = ', payload);
      dispatch({
        type: types.REQUEST_COMPLETE,
        payload: payload,
      });
    }
  };
};


export const updateFullPageLoadingState = (payload) => {
  return {
    type: types.FULL_PAGE_LOADING_STATE,
    payload,
  };
};

// Full page takeover LoadingState ui hook
export const hideFullPageLoadingState = (payload) => {

  return updateFullPageLoadingState({
    loading: false,
    ...payload,
  });
};

export const showFullPageLoadingState = (payload) => {

  return updateFullPageLoadingState({
    loading: true,
    ...payload,
  });
};



// WEBPACK FOOTER //
// ./src/actions/loadingState/loadingStateActions.js